<template>
    <button @click="list" type="button" class="btn btn-info">
        <font-awesome-icon icon="users"/>&nbsp;{{$t('clientUserGroup')}}
        <b-modal size="lg" v-model="showList" :title="$t('title')" @ok="closed" @close="closed" ok-only no-close-on-backdrop no-enforce-focus>
            <div class="row">
                <div class="col-12">
                    <b-tabs v-model="filterFormModel.status" @input="load">
                        <b-tab :title="$t('activated')"></b-tab>
                        <b-tab :title="$t('deactivated')"></b-tab>
                    </b-tabs>
                    <div class="tile">
                        <div class="form-inline">
                            <b-form-input class="mr-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load" :placeholder="$t('keyword')"></b-form-input>
                            <button @click="load" class="btn btn-primary mr-1 mb-1">{{$t('search')}}</button>
                            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <p class="pull-left" v-if="itemCount">{{$t('found', [itemCount])}}</p>
                    <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
                    <button @click="create" class="btn btn-sm btn-success pull-right">
                        <font-awesome-icon icon="plus"/>&nbsp;{{$t('create')}}
                    </button>
                </div>
                <div class="col-12" v-if="items.length">
                    <div class="c-smart-table tile">
                        <div class="row c-smart-table__title">
                            <div class="col-lg-2">{{$t('ext')}}</div>
                            <div class="col-lg-2">{{$t('name')}}</div>
                            <div class="col-lg-2">{{$t('desc')}}</div>
                            <div class="col-lg-2">{{$t('status')}}</div>
                            <div class="col-lg-4"></div>
                        </div>
                        <div class="row" v-for="item in items" :key="item._id">
                            <div class="col-lg-2">
                                <b class="c-smart-table__label">{{$t('ext')}}: </b>
                                <span>{{item.ext}}</span>
                            </div>
                            <div class="col-lg-2">
                                <b class="c-smart-table__label">{{$t('name')}}: </b>
                                <span>{{item.name}}</span>
                            </div>
                            <div class="col-lg-2">
                                <b class="c-smart-table__label">{{$t('desc')}}: </b>
                                <span>{{item.desc}}</span>
                            </div>
                            <div class="col-lg-2">
                                <p>
                                    <label v-if="item.active" class="badge badge-success">{{$t('activated')}}</label>
                                    <label v-if="!item.active" class="badge badge-danger">{{$t('deactivated')}}</label>
                                </p>
                            </div>
                            <div class="col-lg-4">
                                <div class="c-smart-table__content">
                                    <div class="c-buttons clearfix is-2">
                                        <div class="c-buttons__col">
                                            <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                                                <font-awesome-icon icon="edit"/>&nbsp;{{$t('edit')}}
                                            </button>
                                            <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1">
                                                <font-awesome-icon icon="trash"/>&nbsp;{{$t('delete')}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center text-danger" v-if="!items.length">
                    <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{$t('notFoundCreate')}}</span>
                    <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{$t('notFoundSearch')}}</span>
                </div>
                <div class="col-12" v-if="itemCount">
                    <p class="pull-left">{{$t('found', [itemCount])}}</p>
                    <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
            <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
            <form-input :label="$t('ext')" :model="formModel" attribute="ext" :errors="formErrors" :placeholder="$t('extPlaceholder')"></form-input>
            <form-textarea :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"></form-textarea>
            <form-checkbox :chk-label="$t('activated')" :model="formModel" attribute="active" :errors="formErrors"></form-checkbox>
        </b-modal>
    </button>
</template>

<script>
    import List from '../../mixins/List';
    import CRUD from "../../mixins/CRUD";

    export default {
        props: ['clientId'],
        mixins: [List, CRUD],
        data() {
            return {
                showList: false,
                service: 'client-user-group',
                defaultFormModel: {
                    client: this.clientId,
                    active: true
                },
                defaultFilterFormModel: {
                    client: this.clientId,
                }
            }
        },
        i18n: {
            messages: {
                en: {
                    clientUserGroup: 'Groups',
                    title: 'Client groups list',
                    ext: 'Extension number',
                    extPlaceholder: '4 digits, not begin by 0'
                },
                vi: {
                    clientUserGroup: 'Nhóm',
                    title: 'Danh sách nhóm',
                    ext: 'Số nhánh',
                    extPlaceholder: '4 số, không bắt đầu bằng 0'
                }
            }
        },
        methods: {
            list() {
                this.showList = true;
            },
            closed() {
                this.$bus.$emit('reloadGroupSelect');
            }
        }
    }
</script>